module.exports = __webpack_public_path__ + "static/media/feature1.beb8b8ba.png";